import { ModalAction, ModalActionTypes } from '../actions/ModalActions';
import { Nullable } from '../types/custom/Nullable';

export interface ModalState {
    termsAndConditionsModal: {
        isOpen: boolean,
        content: Nullable<string>,
        modalTitle: Nullable<string>,
    }
}

const INITIAL_STATE: ModalState = {
    termsAndConditionsModal: {
        isOpen: false,
        content: null,
        modalTitle: null,
    }
};

const modalState = (state = INITIAL_STATE, action: ModalAction): ModalState => {
    switch (action.type) {
        case ModalActionTypes.TERMS_AND_CONDITIONS_MODAL_OPEN:
            return {
                ...state,
                termsAndConditionsModal: {
                    isOpen: true,
                    content: action.content,
                    modalTitle: action.modalTitle,
                }
            };
        case ModalActionTypes.TERMS_AND_CONDITIONS_MODAL_CLOSE:
            return {
                ...state,
                termsAndConditionsModal: {
                    isOpen: false,
                    content: null,
                    modalTitle: null,
                }
            };
        default:
            return state;
    }
};

export default modalState;